import { useLocation } from "react-router-dom";
// Imports comentados - módulos no disponibles en tipify-web
// import CryptoJS from "crypto-js";
// import {
//   TPV_LANGUAGE_CODES,
//   TPV_MERCHANT_CODE,
//   TPV_MERCHANT_KEY,
//   TPV_MERCHANT_TERMINAL,
// } from "../constants/constants";
// import { useLang } from "../translations/i18n";

export const toAbsoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname;

// GetCurrentLanguage comentado - requiere useLang que no está disponible
// export function GetCurrentLanguage() {
//   return useLang();
// }

export function randomizer(list) {
  for (let i = list.length - 1; i > 0; i--) {
    const randomIndex = Math.floor(Math.random() * (i + 1));
    [list[i], list[randomIndex]] = [list[randomIndex], list[i]];
  }
  return list;
}

// getValueOfCurrentLanguage comentado - requiere GetCurrentLanguage
// export const getValueOfCurrentLanguage = (field, lang) => {
//   const language = lang ? lang : GetCurrentLanguage();
//   if (!field || !Object.keys(field)?.length) return "----";
//   if (field[language] && field[language] !== "") return field[language];
//   for (const lang of Object.keys(field)) {
//     if (field[lang] && field[lang] !== "") return field[lang];
//   }
//
//   return "----";
// };

function extractContent(s) {
  if (!s) return "----";
  var span = document.createElement("span");
  span.innerHTML = s;
  return span.textContent || span.innerText;
}

export function substringFormatter(cell, length) {
  let size = length ? length : 50;
  const text = extractContent(cell);
  return text.length > size ? text.substring(0, size) + "..." : text;
}

export function getFriendlyURL(text) {
  var a = "àáäâèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;";
  var b = "aaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------";
  var p = new RegExp(a.split("").join("|"), "g");

  if (!text) return;

  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(p, function (c) {
      return b.charAt(a.indexOf(c));
    })
    .replace(/&/g, "-y-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
}

export function getViewport() {
  const width = Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0
  );
  if (width <= 576) return "xs";
  if (width <= 768) return "sm";
  if (width <= 992) return "md";
  if (width <= 1200) return "lg";
  return "xl";
}

function GetLocation() {
  return useLocation();
}

export function isCurrentPath(path) {
  const location = GetLocation();
  return location.pathname === path;
}

export function getDistanceBetweenTwoLocations(lat1, lon1, lat2, lon2) {
  var R = 6371; // km
  var dLat = toRad(lat2 - lat1);
  var dLon = toRad(lon2 - lon1);
  var lat1 = toRad(lat1);
  var lat2 = toRad(lat2);

  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d; //km;
}

// Converts numeric degrees to radians
function toRad(Value) {
  return (Value * Math.PI) / 180;
}

export const storeModalityToSession = (value) => {
  window.sessionStorage.setItem("modality", value);
};

export const storeCategoriesToSession = (value) => {
  window.sessionStorage.setItem("categories", JSON.stringify(value));
};

export const storePriceToSession = (value) => {
  window.sessionStorage.setItem("price", value);
};

export const removeModalityFromSession = () => {
  window.sessionStorage.removeItem("modality");
};

export const removeCategoriesFromSession = () => {
  window.sessionStorage.removeItem("categories");
};

export const removePriceFromSession = () => {
  window.sessionStorage.removeItem("price");
};

export const getModalityFromSession = () => {
  let item = window.sessionStorage.getItem("modality");
  if (item === "undefined") return null;
  return item;
};

export const getCategoriesFromSession = () => {
  let item = window.sessionStorage.getItem("categories");
  if (item === "undefined") return null;
  return JSON.parse(item);
};

export const getPriceFromSession = () => {
  let item = window.sessionStorage.getItem("price");
  if (item === "undefined") return null;
  return item;
};

// Generar o obtener UUID único de sesión para identificar usuarios
export const getSessionUUID = () => {
  const STORAGE_KEY = "tipify_session_uuid";
  let uuid = window.sessionStorage.getItem(STORAGE_KEY);

  if (!uuid) {
    // Generar UUID v4 simple
    uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
    window.sessionStorage.setItem(STORAGE_KEY, uuid);
  }

  return uuid;
};

export const chunkArray = (array, chunkSize) => {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};

export const getFileType = (fileName) => {
  if (!fileName) return "unknown";
  const ext = fileName.split(".").pop();
  switch (ext) {
    case "pdf":
      return "file";
    case "m4a":
      return "audio";
    case "mp3":
      return "audio";
    case "mpa":
      return "audio";
    case "wma":
      return "audio";
    case "aif":
      return "audio";
    case "cda":
      return "audio";
    case "mid":
      return "audio";
    case "midi":
      return "audio";
    case "ogg":
      return "audio";
    case "wav":
      return "audio";
    case "wpl":
      return "audio";
    case "jpg":
      return "image";
    case "jpeg":
      return "image";
    case "png":
      return "image";
    case "svg":
      return "image";
    case "gif":
      return "image";
    case "webp":
      return "image";
    case "avi":
      return "video";
    case "m4v":
      return "video";
    case "mkw":
      return "video";
    case "mp4":
      return "video";
    case "wmv":
      return "video";
    case "mov":
      return "video";
    default:
      return "unknown";
  }
};

export function isValidObjectID(str) {
  const objectIDPattern = /^[0-9a-fA-F]{24}$/;
  return objectIDPattern.test(str);
}

// generateAndSignTPVData comentado - requiere CryptoJS y constantes TPV no disponibles
// export function generateAndSignTPVData({
//   language,
//   orderNumber,
//   price,
//   description,
//   additionalData,
//   notificationURL,
//   callbackUrlOK,
//   callbackUrlKO,
// }) {
//   const formattedPrice = parseFloat(price)
//     .toFixed(2)
//     .toString()
//     .replace(".", "");
//   const formattedAdditionalData = CryptoJS.enc.Utf8.parse(
//     JSON.stringify(additionalData)
//   ).toString(CryptoJS.enc.Base64);
//
//   const requestBody = {
//     DS_MERCHANT_AMOUNT: formattedPrice,
//     DS_MERCHANT_CURRENCY: "978", //€
//     DS_MERCHANT_MERCHANTCODE: TPV_MERCHANT_CODE,
//     DS_MERCHANT_ORDER: orderNumber,
//     DS_MERCHANT_TERMINAL: TPV_MERCHANT_TERMINAL,
//     DS_MERCHANT_PRODUCTDESCRIPTION: description,
//     DS_MERCHANT_CONSUMERLANGUAGE: TPV_LANGUAGE_CODES[language] || "0",
//     DS_MERCHANT_MERCHANTDATA: formattedAdditionalData,
//     DS_MERCHANT_MERCHANTURL: notificationURL,
//     DS_MERCHANT_URLOK: callbackUrlOK,
//     DS_MERCHANT_URLKO: callbackUrlKO,
//     DS_MERCHANT_TRANSACTIONTYPE: "0",
//   };
//
//   var merchantWordArray = CryptoJS.enc.Utf8.parse(JSON.stringify(requestBody));
//   var merchantParametersBase64 = merchantWordArray.toString(
//     CryptoJS.enc.Base64
//   );
//
//   // Decode key
//   var keyWordArray = CryptoJS.enc.Base64.parse(TPV_MERCHANT_KEY);
//
//   // Generate transaction key
//   var iv = CryptoJS.enc.Hex.parse("0000000000000000");
//   var cipher = CryptoJS.TripleDES.encrypt(
//     requestBody.DS_MERCHANT_ORDER,
//     keyWordArray,
//     {
//       iv: iv,
//       mode: CryptoJS.mode.CBC,
//       padding: CryptoJS.pad.ZeroPadding,
//     }
//   );
//
//   // Sign
//   var signature = CryptoJS.HmacSHA256(
//     merchantParametersBase64,
//     cipher.ciphertext
//   );
//   var signatureBase64 = signature.toString(CryptoJS.enc.Base64);
//
//   const merchantTPVInfo = {
//     merchantParameters: merchantParametersBase64,
//     signatureVersion: "HMAC_SHA256_V1",
//     signature: signatureBase64,
//   };
//
//   return merchantTPVInfo;
// }

// isValidAndAuthorizedTPVOperation comentado - requiere CryptoJS
// export function isValidAndAuthorizedTPVOperation({
//   operationMerchantParametersBase64,
//   operationSignatureBase64,
// }) {
//   if (!operationMerchantParametersBase64 || !operationSignatureBase64)
//     return false;
//
//   const merchantParameters = JSON.parse(
//     CryptoJS.enc.Utf8.stringify(
//       CryptoJS.enc.Base64.parse(operationMerchantParametersBase64)
//     )
//   );
//
//   //Validate signature and check if operation is valid
//   //TO DO: Validate signature
//
//   /*
// 	var keyWordArray = CryptoJS.enc.Base64.parse(TPV_MERCHANT_KEY);
//
// 	var iv = CryptoJS.enc.Hex.parse("0000000000000000");
// 	var cipher = CryptoJS.TripleDES.encrypt(
// 		merchantParameters.Ds_Order,
// 		keyWordArray,
// 		{
// 			iv: iv,
// 			mode: CryptoJS.mode.CBC,
// 			padding: CryptoJS.pad.ZeroPadding,
// 		}
// 	);
//
// 	var signature = CryptoJS.HmacSHA256(
// 		operationMerchantParametersBase64,
// 		cipher.ciphertext
// 	);
//
// 	var signatureBase64 = signature.toString(CryptoJS.enc.Base64);
//
// 	if (
// 		operationSignatureBase64 &&
// 		signatureBase64 !== operationSignatureBase64
// 	)
// 		return false;
// 	*/
//
//   const responseCode = merchantParameters.Ds_Response.toString();
//
//   if (responseCode === "9915") return null; //user has cancelled the operation
//
//   const authorizedOperation = responseCode >= "0000" && responseCode <= "0099";
//
//   return authorizedOperation;
// }

export function calculateCommissionFee(commission, basePrice) {
  let fee = 0;
  if (commission?.percentage) fee = basePrice * (commission?.percentage / 100);
  else if (commission?.absoluteAmount)
    fee = Math.min(commission?.absoluteAmount, basePrice);

  return fee;
}
export const calcularTasaFinal = (importe, tasa) => {
  if (!tasa || !importe) return 0;

  const tasaCalculada = parseFloat(
    (
      (importe * (Number(tasa.percentage || 0) + Number(tasa.percentagePlan || 0))) / 100 +
      Number(tasa.fijo || 0)
    ).toFixed(2)
  );
  const min = tasa.minimumAmount || 0;
  const max = tasa.maximumAmount || Infinity;

  return Math.min(Math.max(tasaCalculada, min), max);
};
